import React, { useState, useEffect } from "react";
import {
  Box,
  Button,
  Checkbox,
  getColor,
  Toggle,
  Typography,
  useToast,
} from "fds";
import "../index.scss";
import { nanoid } from "@reduxjs/toolkit";
import { NotificationDTO } from "../../../types/workgroup";
import usePolicyStore from "../../../redux/dispatcher/usePolicyStore";
import { t } from "i18next";
import { file_alert_type } from "../../WorkgroupModal/WorkgroupAlarmTab";
import classNames from "classnames";
import { getUserInfoFromLocalStorage } from "../../../shared/utils/auth";
import { LoginDto } from "../../../types/auth";
interface AlarmTabProps {
  open: boolean;
}

const AlarmTab: React.FC<AlarmTabProps> = ({ open }) => {
  const user = getUserInfoFromLocalStorage() as string | "";
  const loginDto: LoginDto = JSON.parse(user);
  /** Hook 정리 */
  const toasts = useToast();
  const { policyState, getPolicyNoti, updatePolicyNoti } = usePolicyStore();

  /** State 정리 */
  const [noti, changeNoti] = useState<NotificationDTO>({
    usingWorkgroupInvitedAlert: false,
    usingFileAlert: false,
    fileAlert: [],
    usingReadRequestAlert: false,
    readRequestAlert: [],
  }); // 알림 정보 저장

  /* useEffect 정리 */
  useEffect(() => {
    if (open) {
      getPolicyNoti().then((resp: any) =>
        changeNoti(
          resp.payload ?? {
            usingWorkgroupInvitedAlert: false,
            usingFileAlert: false,
            fileAlert: [],
            usingReadRequestAlert: false,
            readRequestAlert: [],
          }
        )
      );
    }
  }, [open]);
  /** 함수 정리 */
  /** 알림 저장 버튼 클릭시 수정된 사항을 저장 */
  const handleUpdateTargetNoti = async () => {
    let resp = await updatePolicyNoti("", noti);
    if (resp.payload) {
      toasts.toastMsg(nanoid(), t("common.alert.editSuccess"), "success");
    } else {
      toasts.toastMsg(nanoid(), t("common.alert.fail"), "error");
    }
  };
  return (
    <Box classes="profileModal-body">
      <Box alignItems="center">
        <Box direction="column" width={"calc(100% - 100px)"}>
          <Typography type="subtitle2">
            {t("header.setAlarm.inviteWorkgroup")}
          </Typography>
          <Typography
            type="body4_rg"
            classes="mg mt-4"
            exactColor={getColor("COLOR_TEXT_SECONDARY")}
          >
            {t("header.setAlarm.inviteWorkgroupDesc")}
          </Typography>
        </Box>
        <Toggle
          classes="mg ml-auto"
          checked={noti.usingWorkgroupInvitedAlert}
          onChange={() =>
            changeNoti({
              ...noti,
              usingWorkgroupInvitedAlert: !noti.usingWorkgroupInvitedAlert,
            })
          }
        />
      </Box>
      <Box
        alignItems="center"
        classes={classNames({
          "mg mt-32":
            loginDto?.ecoSystemLicenseStats?.featureAccessType !== "LITE",
        })}
        width={"100%"}
      >
        <Box direction="column" width={"calc(100% - 100px)"}>
          <Typography type="subtitle2">
            {t("header.setAlarm.fileUpdate")}
          </Typography>
          <Typography
            type="body4_rg"
            classes="mg mt-4"
            exactColor={getColor("COLOR_TEXT_SECONDARY")}
          >
            {t("header.setAlarm.fileUpdateDesc")}
          </Typography>
        </Box>
        <Toggle
          classes="mg ml-auto"
          checked={noti.usingFileAlert}
          onChange={() =>
            changeNoti({
              ...noti,
              usingFileAlert: !noti.usingFileAlert,
              fileAlert: [],
            })
          }
        />
      </Box>
      {noti.usingFileAlert && (
        <Box direction="column">
          {file_alert_type.map((item1) => (
            <Checkbox
              label={item1.name}
              justifyContent="flex-start"
              classDiv="mg mt-20"
              check={noti.fileAlert?.includes(item1.key)}
              onClick={() =>
                changeNoti({
                  ...noti,
                  fileAlert: noti.fileAlert?.includes(item1.key)
                    ? noti.fileAlert?.filter((item) => item !== item1.key)
                    : noti.fileAlert
                    ? [...noti.fileAlert, item1.key]
                    : [item1.key],
                })
              }
            />
          ))}
        </Box>
      )}
      <Box alignItems="center" classes="mg mt-32">
        <Box direction="column" width={"calc(100% - 100px)"}>
          <Typography type="subtitle2">
            {t("header.setAlarm.request")}
          </Typography>
          <Typography
            type="body4_rg"
            classes="mg mt-4"
            exactColor={getColor("COLOR_TEXT_SECONDARY")}
          >
            {t("header.setAlarm.requestDesc")}
          </Typography>
        </Box>
        <Toggle
          classes="mg ml-auto"
          checked={noti.usingReadRequestAlert}
          onChange={() =>
            changeNoti({
              ...noti,
              usingReadRequestAlert: !noti.usingReadRequestAlert,
              readRequestAlert: [],
            })
          }
        />
      </Box>
      {noti.usingReadRequestAlert && (
        <Box direction="column">
          {[
            {
              resource: t("header.setAlarm.requestRecieve"),
              key: "readRequest",
            },
            {
              resource: t("header.setAlarm.confirmRequest"),
              key: "readRequestConfirm",
            },
          ].map((item1) => (
            <Checkbox
              label={item1.resource}
              justifyContent="flex-start"
              classDiv="mg mt-20"
              check={noti.readRequestAlert?.includes(item1.key)}
              onClick={() =>
                changeNoti({
                  ...noti,
                  readRequestAlert: noti.readRequestAlert?.includes(item1.key)
                    ? noti.readRequestAlert?.filter(
                        (item) => item !== item1.key
                      )
                    : noti.readRequestAlert
                    ? [...noti.readRequestAlert, item1.key]
                    : [],
                })
              }
            />
          ))}
        </Box>
      )}
      <Button
        label={t("common.save")}
        btnStyle="fill"
        width="fit-content"
        classes="mg ml-auto mt-auto"
        state={
          JSON.stringify(policyState.policyNoti) === JSON.stringify(noti)
            ? "disable"
            : "default"
        }
        onClick={handleUpdateTargetNoti}
      />
    </Box>
  );
};

export default AlarmTab;
